/** * * Asynchronously loads the component for
DoNotSellMyData
* */ import { lazyLoad } from "utils/loadable";
export const DoNotSellMyData = lazyLoad(
  () => import("./index"),
  (module) => module.DoNotSellMyData
);
